import type { LensDefinition } from '../models/explorer/ExplorerLens';
import {
  iconForCategory,
  resolveCategoryForNode,
} from './providerIcons';

/**
 * P1.4a — AWS icon lens. Stamps `attrs.lens.icon` with a categorical
 * glyph keyed off the node's manifest id / type.
 *
 * Decoration also carries a neutral badge so the lens menu shows
 * something useful, and returns `dataMissing: true` for nodes that
 * resolve to an unknown service so untagged resources render with a
 * "no icon" indicator instead of the wrong glyph.
 */
export const awsIconLens: LensDefinition = {
  id: 'aws-icons',
  label: 'AWS icons',
  description: 'Provider-icon view — colours resources by AWS service category.',

  decorate(node) {
    const props = (node.props ?? {}) as Record<string, unknown>;
    const manifestId =
      (props._manifestId as string | undefined) ??
      (props.manifestId as string | undefined) ??
      node.type;
    const category = resolveCategoryForNode('aws', manifestId);
    if (!category) {
      return {
        dataMissing: true,
        badge: { label: 'unknown service', tone: 'neutral' },
      };
    }
    return {
      icon: iconForCategory(category),
      badge: { label: category, tone: 'neutral' },
    };
  },
};
